"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionComponentContainer = void 0;
var react_1 = __importDefault(require("react"));
var Panel_1 = require("../Panel");
exports.SelectionComponentContainer = function (props) {
    var _a;
    return (react_1.default.createElement(Panel_1.Panel, { isOpen: props.isOpen, anchorElement: props.controlElement, onRequestClose: props.requestClose, children: props.children, disableXSnapping: true, 
        // TODO panel configuration
        panelSize: { width: (_a = props.width) !== null && _a !== void 0 ? _a : "matchAnchor", height: "auto" }, anchorElementClickable: props.interactiveControl }));
};
//# sourceMappingURL=SelectionComponentContainer.js.map